// Services
import { apiInstance, gql } from "@/services/httpAdapter";

// Utils
import { errorLogger } from "@/Common/helpers/logger";

// Types
import { IPaginationInput } from "@Common/types/common-queries";

export async function getAuthorizationGroupsAccess(locationId: string, pagination: IPaginationInput) {
	const query = gql`
		query getAuthorizationGroupsAccess($locationId: String!, $pagination: PaginationInput) {
			getAuthorizationGroupsAccess(locationId: $locationId, pagination: $pagination) {
				items {
					_id
					actions {
						_id
						actionDescription
						actionName
						category
						actionKey
					}
					groupDescription
					groupName
					locationId
					users {
						_id
						fullName
						position
						locationId
						locationName
					}
				}
				pageInfo {
					hasNextPage
					endCursor
				}
			}
		}
	`;

	const variables = {
		locationId,
		pagination,
	};

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.getAuthorizationGroupsAccess ?? null;
	} catch (err) {
		errorLogger(err as Error, {
			function: "getAuthorizationGroupsAccess",
			message: "Error getting authorization groups access",
			variables,
		});
		return null;
	}
}
